import { testimonials } from '@/mocks/homeData';

export default function Testimonials() {
  return (
    <section className="py-16 md:py-20 bg-background-50" aria-labelledby="testimonials-title">
      <div className="px-4 md:px-6">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-10">
            <span className="inline-flex items-center gap-1.5 text-xs font-medium text-foreground-500 mb-3">
              <span className="w-1.5 h-1.5 rounded-full bg-primary-500"></span>
              漫迷口碑
            </span>
            <h2 id="testimonials-title" className="font-heading text-3xl md:text-4xl text-foreground-950">
              听听读者们<span className="text-primary-500">怎么说</span>
            </h2>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
            {testimonials.map((item) => (
              <article
                key={item.id}
                className="bg-background-100 rounded-xl p-5 flex flex-col"
              >
                <div className="flex items-center gap-1 mb-3">
                  {[...Array(item.rating)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-accent-500 text-sm"></i>
                  ))}
                </div>
                <blockquote className="text-foreground-700 text-sm leading-relaxed flex-1 mb-4">
                  &ldquo;{item.content}&rdquo;
                </blockquote>
                <div className="flex items-center gap-3 pt-4 border-t border-background-200/70">
                  <img
                    src={item.avatar}
                    alt={item.name}
                    className="w-10 h-10 rounded-full object-cover"
                    loading="lazy"
                  />
                  <div>
                    <p className="text-foreground-900 text-sm font-medium">{item.name}</p>
                    <p className="text-foreground-500 text-xs">{item.role}</p>
                  </div>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}